
export default {
  data() {
    return {

      form : {
                id : '',
                uraian : '',
                indikator : '',
                tahun : '',
            },
      unit_kerja : '',

      namaUnit : '',
      namaIndikator : '',

      outcome: [],
     
      list_data : [],
      list_outcome : [],
      list_unit : [],
      list_kolom : [],
      list_indikator : [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,

    }
  },
  methods: {

    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_OUTCOME + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              unit_kerja : this.unit_kerja,
              indikator : this.form.indikator,
              // tahun : this.form.tahun
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data;
              console.log(this.list_data);
              this.list_outcome = this.list_data;
              this.page_last = res_data.length;
              console.log(this.page_last);
              console.log(this.list_outcome);
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    getUnit : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit+"view", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_unit = res_data;
              this.$store.commit("hideLoading");
      });
    },

    getIndikator : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_KOLOM+"indikator", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              unit_kerja : this.unit_kerja
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_indikator = res_data;
              this.$store.commit("hideLoading");
      });
    },

    getKolom : function(){
      this.$store.commit("shoWLoading");
      console.log("adsjjavsfj");
      fetch(this.$store.state.url.URL_OUTCOME+"kolom", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              unit_kerja : this.unit_kerja,
              indikator : this.form.indikator
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_kolom = res_data;
              var hasil = res_data;
              for(var i in hasil) {
                    this.outcome.push({"indikatorKolomId" : hasil[i].id, "kolom" : hasil[i].uraian, value: ' '});
                }
                console.log(this.outcome);
              this.$store.commit("hideLoading");
      });
    },

    getTahun : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_tahun = res_data;
              this.$store.commit("hideLoading");
      });
    },

    cetakUnit : function(){
      console.log(this.unit_kerja);
      fetch(this.$store.state.url.URL_OUTCOME+"cetak_unit", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            unit_kerja : this.unit_kerja
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.namaUnit = res_data[0].unit_kerja;
      });
    },

    cetakIndikator : function(){
      fetch(this.$store.state.url.URL_OUTCOME+"cetak_indikator", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            indikator : this.form.indikator
          })
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.namaIndikator = res_data[0].uraian;
      });
    },

    getKecamatan : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan+"view", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              console.log(res_data);
              this.list_kecamatan = res_data;

              console.log(this.list_kecamatan);
              this.$store.commit("hideLoading");
      });
    },

    addData : function() {
      fetch(this.$store.state.url.URL_OUTCOME + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            outcome : this.outcome,
            indikator : this.form.indikator
          })
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'light-blue-14', 'check_circle_outline');
          console.log(res_data);
          this.getView();
          this.getUnit();
          this.getIndikator();
      });
    },


    editData : function(){
      fetch(this.$store.state.url.URL_KOLOM + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'lime-7', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(a){
      fetch(this.$store.state.url.URL_KOLOM + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-10', 'check_circle_outline');
          this.getView();
      });

    },

//     printDivContent(printCetak) {
//   const content = document.getElementById(printCetak).innerHTML;
//   const printWindow = window.open('', '_blank');
//   printWindow.document.write('<html><head><title>LPPD</title></head><body>');
//   printWindow.document.write(content);
//   printWindow.document.write('</body></html>');
//   printWindow.document.close();
//   printWindow.print();
// },

printTable() {
      const printWindow = window.open('', '_blank');
      const content = document.getElementById('printCetak').innerHTML;
      const style = `
        <link rel="stylesheet" type="text/css" href="css/kiken.css">
        <link rel="stylesheet" type="text/css" href="css/bg.css">
        <link rel="stylesheet" type="text/css" href="css/huruf.css">
      `;

      printWindow.document.write('<html><head><title>Data LPPD</title>' + style + '</head><body>');
      printWindow.document.write(content);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    },

    selectData : function(datax){
      console.log(datax);
        this.form.id = datax.id
        // this.form.uraian = data.uraian
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

    // ====================================== PAGINATE ====================================

  },

  mounted () {
    this.getView();
    this.getUnit();
    this.getKolom();
    this.getIndikator();
    this.getTahun();
    this.getKecamatan();
  },
}
